import { render, staticRenderFns } from "./reviewLocation.vue?vue&type=template&id=6953444e&scoped=true"
import script from "./reviewLocation.vue?vue&type=script&lang=js"
export * from "./reviewLocation.vue?vue&type=script&lang=js"
import style0 from "./reviewLocation.vue?vue&type=style&index=0&id=6953444e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953444e",
  null
  
)

export default component.exports